import { createItemFinderOutputV1 } from './ItemFinderOutputV1';
import { createTableDefinitionOutputV1 } from './TableDefinitionOutputV1';
import type { FactoryOverrides } from '../../target/generated/sdk/variables';

/**
 * Application-wide factory defaults for SDK models.
 *
 * These overrides are applied to all factory-generated mock data, providing
 * consistent test defaults across the application. Individual tests can still
 * override these values by passing overrides to the factory function.
 *
 * Order of precedence:
 * 1. Base factory defaults (from generated factory)
 * 2. Config overrides (from this file)
 * 3. Test-specific overrides (passed to factory function)
 */

/** Default model overrides used by generated test factories. */
export const factoryOverrides: FactoryOverrides = {
  TableDefinitionOutputV1: createTableDefinitionOutputV1,
  ItemFinderOutputV1: createItemFinderOutputV1,
};
